import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** 支払いサイクル */
enum PaymentMethod {
  /** 先払い */
  advancePayment = '1',
  /** 後払い */
  laterPayment = '2',
}

const nameConfig = {
  advancePayment: new Map([[Locale.ja, '先払い']]),
  laterPayment: new Map([[Locale.ja, '後払い']]),
};

const toEnum = rawValueToEnum(PaymentMethod, PaymentMethod.advancePayment);
const toDisplay = enumToName(PaymentMethod, nameConfig);
const toDisplayWithPrefix = enumToName(PaymentMethod, nameConfig, { prefix: true });

export const paymentMethod = {
  enum: PaymentMethod,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { PaymentMethod };
